import Lenis from 'lenis'
import ScrollTrigger from 'gsap/ScrollTrigger'
import gsap from 'gsap'
gsap.registerPlugin(ScrollTrigger)

class SmoothScroll {
  constructor () {
    this.lenis = new Lenis({
      duration: 1.2,
      smoothWheel: true,
      normalizeWheel: true,
      smoothTouch: false,
    })

    this.onScroll = this.onScroll.bind(this)
    this.onRaf = this.onRaf.bind(this)
  }

  init () {
    gsap.ticker.add(this.onRaf)
    this.onScroll()
  }

  onRaf (time) {
    this.lenis.raf(time * 1000)
  }

  onScroll () {
    this.lenis.on('scroll', ({ scroll, limit, velocity, direction, progress }) => {
      ScrollTrigger.update()
    })
  }

  stop () {
    this.lenis.stop()
  }

  start () {
    this.lenis.start()
    this.lenis.resize()
  }

  destroy () {
    this.lenis.destroy()
    this.lenis.off('scroll')
    gsap.ticker.remove(this.onRaf)
  }
}

export default SmoothScroll



//////////////////
// WEBPACK FOOTER
// ./scripts/util/SmoothScroll.js
// module id = 16
// module chunks = 0